// extracted by mini-css-extract-plugin
module.exports = {"userNavItem":"_2WL5cj","avatar":"_1HKOu_","name":"_1TWNcB","arrow":"xtRwLl"};